import { render } from "./BuildButtons.vue?vue&type=template&id=690a02f4&ts=true"
import script from "./BuildButtons.vue?vue&type=script&lang=ts"
export * from "./BuildButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__